import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import CheckBoxSelect from '../Select/CheckBoxSelect';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
   container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      height: '50vh',
      overflow: 'scroll',
   },
   groupName: {
      fontSize: '22px',
      fontWeight: 600,
   },
   checkbox: {
      fontFamily: `'DBHeavent', sans-serif `,
   },
   label: { fontFamily: `'DBHeavent', sans-serif ` },
}));
const CheckBoxGroup = (props) => {
   const classes = useStyles();
   const [parentCheckboxChecked, setParentCheckboxChecked] = useState(false);
   const [checkboxesGrouped, setCheckboxesGrouped] = useState(null);
   const handleParentCheckboxChange = (isChecked) => {
      const { checkboxes, onCheckboxGroupChange } = props;
      const newCheckState = checkboxes.map((aCheckbox) => ({
         ...aCheckbox,
         checked: isChecked,
      }));
      onCheckboxGroupChange(newCheckState);
   };
   useEffect(() => {
      updateParentWithChildren(props);
   });

   useEffect(() => {
      let checkboxesGrouped = _(props.checkboxes)
         .groupBy((x) => x.groupId)
         .map((value, key) => ({
            groupId: parseInt(key),
            groupName: value[0].groupName,
         }))
         .value();
      setCheckboxesGrouped(checkboxesGrouped);
   }, [props.checkboxes]);

   const updateParentWithChildren = (props) => {
      const { checkboxes } = props;
      let allChecked = false;
      for (let i = 0; i < checkboxes.length; i += 1) {
         if (checkboxes[i].checked) {
            allChecked = true;
         } else {
            allChecked = false;
            break;
         }
      }
      setParentCheckboxChecked(allChecked);
   };
   const handleChildCheckboxChange = (isChecked, index) => {
      const { checkboxes } = props;
      const { onCheckboxGroupChange } = props;
      const newCheckState = checkboxes.map((aCheckbox, i) =>
         index === i ? { ...aCheckbox, checked: isChecked } : aCheckbox,
      );
      onCheckboxGroupChange(newCheckState);
   };
   const renderCheckboxes = () => {
      const { checkboxes } = props;
      if (!checkboxes) {
         return null;
      }
      return (
         <div className={classes.container}>
            {checkboxesGrouped &&
               checkboxesGrouped.map((el) => (
                  <div key={el.groupId}>
                     <div className={classes.groupName}>{el.groupName}</div>
                     {checkboxes.map(
                        (aCheckbox, index) =>
                           aCheckbox.groupId == el.groupId && (
                              <div key={index}>
                                 <CheckBoxSelect
                                    disabled={
                                       aCheckbox.disabled ||
                                       props.disabledAll ||
                                       !aCheckbox.canEdit
                                    }
                                    key={index}
                                    checkboxLabel={aCheckbox.label}
                                    checkboxValue={aCheckbox.value}
                                    checked={aCheckbox.checked}
                                    size={'small'}
                                    checkboxChangeCallback={(checkStatus) =>
                                       handleChildCheckboxChange(
                                          checkStatus,
                                          index,
                                       )
                                    }
                                 />
                              </div>
                           ),
                     )}
                  </div>
               ))}
         </div>
      );
   };
   return (
      <Box>
         <CheckBoxSelect
            disabled={props.disabledAll}
            checkboxLabel={props.title}
            checkboxValue='allBO'
            checked={parentCheckboxChecked}
            checkboxChangeCallback={handleParentCheckboxChange}
         />
         <Divider />
         <Box
            p={2}
            display='flex'
            flexDirection='column'
            className='checkbox-children'
         >
            {renderCheckboxes()}
         </Box>
      </Box>
   );
};

export default CheckBoxGroup;
